import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getNetwork, isDefaultNetwork } from 'app/scripts/services/app-state';

class LoginPageTitle extends Component {
  render() {
    var network = getNetwork();
    var component = null;
    if (isDefaultNetwork()) {
      component = <span className="title">Log In to Your Account</span>;
    } else {
      component = <span className="title">{`Log In to ${network.name}`} </span>;
    }

    return <div className="text-section">{component}</div>;
  }
}

LoginPageTitle.displayName = 'LoginPageTitle';

export default LoginPageTitle;
